import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApi from "../../api/adminApi";

export const useDeleteBranch = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: number) => adminApi.deleteBranch(id),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["branches"],
            });
        },
    });
};
